//@ts-ignore
//@ts-nocheck
/* eslint-disable @typescript-eslint/no-unused-expressions, no-debugger, no-console, prefer-const, prefer-rest-params,  no-sequences */
import useTracker from "../../useTrackerContext";
import Typography from "@mui/material/Typography";
import CTrackerTimelineItem from "components/CTimelineItem";
import API from "utils/API";
import moment from "moment";
import CButton from "components/CButton";
import CDialog from "components/CDialog";
import isHolliday from "utils/isHolliday";
import { Close } from "@mui/icons-material";
import CCalendar from "components/CCalendar";
import NotarizeLogo from "./NotarizeLogo.svg";
import { Box, Container, IconButton, useTheme } from "@mui/material";
import addWorkingDays from "utils/addWorkingDays";
import { Fragment, useCallback, useEffect, useMemo, useState } from "react";
import useUser from "context/UserCustomer/useUserCustomerContext";
import { TrackerStatusColor } from "typedef/TrackerStatusColor";
import dayjs from "dayjs";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { TimePicker } from "@mui/x-date-pickers/TimePicker";
import CTextField from "components/CTextField";
import { renderTimeViewClock } from "@mui/x-date-pickers";

const ScheduleClosingVerification: React.FC<{
  trackerStatusColor: TrackerStatusColor;
}> = ({ trackerStatusColor }) => {
  const theme = useTheme();
  const { loan, type } = useTracker();
  const isBorrower = type === "borrower";
  const step = isBorrower ? loan?.borrowerSteps : loan?.coborrowerSteps;
  const { user } = useUser();
  const [showNPS, setShowNPS] = useState(false);
  const [calendarIsOpen, setCalendarIsOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState<Date>();
  const [selectedTime, setSelectedTime] = useState<Dayjs | null>();
  const [personaDialogIsOpen, setPersonaDialogIsOpen] = useState(false);
  const [dateClosing, setDateClosing] = useState("");
  const isUnsupportedCountyFips = loan?.property?.isUnsupportedCountyFips;
  const borrowerSteps = loan?.borrowerSteps;
  const employmentType = isBorrower
    ? loan?.borrowerEmploymentType
    : loan?.coborrowerEmploymentType;
  const borrowerDone =
    (borrowerSteps?.incomeVerification.status === "success" &&
      borrowerSteps.disclosuresVerification.status === "success") ||
    borrowerSteps?.scheduleClosingVerification?.status === "success";

  const coborrowerDone = loan?.coborrowerSteps
    ? (loan.coborrowerSteps?.incomeVerification.status === "success" &&
        loan.coborrowerSteps.disclosuresVerification.status === "success") ||
      borrowerSteps?.scheduleClosingVerification?.status === "success"
    : true;

  const prevStep =
    step?.creditVerification.status === "success" &&
    loan?.borrowerSteps?.homeValuationVerification.status === "success" &&
    borrowerDone &&
    coborrowerDone;

  const status = prevStep
    ? loan?.borrowerSteps?.scheduleClosingVerification?.status ?? "pending"
    : "pending";
  const initialDisclosuresSigned =
    loan?.borrowerSteps?.disclosuresVerification?.status === "success";
  const isTexas =
    loan?.property?.address?.components?.state_abbreviation === "TX";
  const message =
    loan?.borrowerSteps?.scheduleClosingVerification?.message ??
    (isTexas &&
      !initialDisclosuresSigned &&
      "You need to sign Initial Disclosures before selecting a closing date");
  const [schedulingDate, setSchedulingDate] = useState(false);
  const [signingAddress, setSigningAddress] = useState();
  const [showSigningAddressForm, setShowSigningAddressForm] = useState();
  const [showChooseAddress, setShowChooseAddress] = useState(true);
  const [customSigningAddress, setCustomSigningAddress] = useState({
    address: "",
    city: "",
    state: "",
    zip: "",
    county: "",
  });
  const [timePickerError, setTimePickerError] = useState(false);

  useEffect(() => {
    const occupancy = loan?.occupancy;
    const isSecondHomeOrInvestment = [
      "Second Home",
      "Investment Property",
    ].includes(occupancy);

    if (isSecondHomeOrInvestment) {
      const deliveryLine = user?.address?.delivery_line_1;
      const city = user?.address?.components?.city_name;
      const state = user?.address?.components?.state_abbreviation;
      const zipcode = user?.address?.components?.zipcode;
      const fullAddress = `${deliveryLine}, ${city}, ${state}, ${zipcode}`;
      setSigningAddress(fullAddress);
    } else {
      setSigningAddress(loan?.property?.fullAddress);
    }
  }, [loan?.property?.fullAddress, user, loan?.occupancy]);

  const [confirm, setConfirm] = useState(false);
  const handleSelectConfirm = async () => {
    setCalendarIsOpen(false);
    setConfirm(true);
  };

  const dateSignedInitial =
    loan?.borrowerSteps?.disclosuresVerification?.dateSigned;

  const signedInitial =
    (loan?.borrowerSteps?.disclosuresVerification?.status === "success" &&
      dateSignedInitial) ??
    false;

  const dayToAddTexas = 12;

  const dateForTexas = moment(dateSignedInitial)
    .add(dayToAddTexas, "days")
    .format("MM/DD/YYYY");

  const showBtnClosingDateTexas = isTexas ? signedInitial : true;

  const daysFrom = loan?.property.isUnsupportedCountyFips ? 2 : 1;
  const daysTo = 10;

  const rangeFrom = useMemo(() => {
    if (prevStep) {
      if (isTexas && signedInitial) return dateForTexas;
      else
        return isUnsupportedCountyFips
          ? addWorkingDays(moment(dateClosing), daysFrom).toDate()
          : moment(dateClosing).toDate();
    }
  }, [
    prevStep,
    daysFrom,
    dateClosing,
    isUnsupportedCountyFips,
    isTexas,
    dateForTexas,
    signedInitial,
  ]);

  const rangeTo = useMemo(() => {
    if (prevStep) {
      const date = isTexas ? dateForTexas : dateClosing;
      return addWorkingDays(moment(date), daysTo).toDate();
    }
  }, [prevStep, dateClosing, daysTo, isTexas, dateForTexas]);

  const disableSubmit = useMemo(() => {
    if (
      selectedDate &&
      moment(selectedDate)?.isBetween(moment(rangeFrom), moment(rangeTo)) &&
      !isHolliday(selectedDate) &&
      (!isTexas ||
        (isUnsupportedCountyFips &&
          isTexas &&
          selectedTime &&
          !timePickerError &&
          !showChooseAddress &&
          ((showSigningAddressForm &&
            customSigningAddress?.address &&
            customSigningAddress?.city &&
            customSigningAddress?.state &&
            customSigningAddress?.zip &&
            customSigningAddress?.county) ||
            (!showSigningAddressForm && signingAddress))))
    ) {
      return false;
    }
    return true;
  }, [
    rangeFrom,
    rangeTo,
    selectedDate,
    selectedTime,
    customSigningAddress,
    signingAddress,
    showChooseAddress,
    showSigningAddressForm,
    isUnsupportedCountyFips,
    timePickerError,
    isTexas,
  ]);

  const scheduleDate = useCallback(async () => {
    if (!selectedDate) return undefined;
    if (isTexas && !selectedTime) return undefined;
    setSchedulingDate(true);

    const date = dayjs(selectedDate).format("YYYY-MM-DD");
    const time = !isTexas ? "12:00" : dayjs(selectedTime).format("HH:mm");

    const combinedDate = dayjs(`${date} ${time}`, {
      format: "YYYY-MM-DD HH:mm",
    }).toString();

    const response = await API.post({
      url: `/schedule-closing-date`,
      data: {
        loanId: loan?.id,
        date: combinedDate,
        customSigningAddress: customSigningAddress.address
          ? customSigningAddress
          : undefined,
      },
    });
    if ("error" in response) {
      setCalendarIsOpen(false);
    } else {
      setShowNPS(true);
      setCalendarIsOpen(false);
      setConfirm(false);
    }
    setSchedulingDate(false);
    setShowChooseAddress(true);
    setShowSigningAddressForm(false);
  }, [selectedDate, selectedTime, customSigningAddress, isTexas, loan?.id]);

  const tentativeDate = useCallback(async () => {
    if (loan?.borrowerSteps?.scheduleClosingVerification.tentativeDate) {
      setDateClosing(
        loan?.borrowerSteps?.scheduleClosingVerification.tentativeDate,
      );
      setPersonaDialogIsOpen(true);
    } else {
      const response = await API.post({
        url: `/save-to-loan/tentative-date?loanId=${loan?.id}`,
      });
      if ("error" in response) {
        console.error(response);
      } else {
        setDateClosing(response);
        setPersonaDialogIsOpen(true);
      }
    }
  }, [loan]);

  useEffect(() => {
    if (showNPS) {
      !(function (e, t, r, n) {
        if (!e[n]) {
          for (
            let a = (e[n] = []),
              i = [
                "survey",
                "reset",
                "config",
                "init",
                "set",
                "get",
                "event",
                "identify",
                "track",
                "page",
                "screen",
                "group",
                "alias",
              ],
              s = 0;
            s < i.length;
            s++
          ) {
            let c = i[s];
            a[c] =
              a[c] ||
              (function (e) {
                return function () {
                  let t = Array.prototype.slice.call(arguments);
                  a.push([e, t]);
                };
              })(c);
          }
          a.SNIPPET_VERSION = "1.0.1";
          let o = t.createElement("script");
          (o.type = "text/javascript"),
            (o.async = !0),
            (o.src =
              "https://d2yyd1h5u9mauk.cloudfront.net/integrations/web/v1/library/" +
              r +
              "/" +
              n +
              ".js");
          let p = t.getElementsByTagName("script")[0];
          p.parentNode.insertBefore(o, p);
        }
      })(window, document, "1QyawY67DwXvYsKQ", "delighted");
      delighted.survey({
        email: user?.email?.trim(),
        name: user?.firstName,
        properties: {
          userId: user?.id,
          address: user?.address,
          employmentType: employmentType,
        },
      });
    }
  }, [showNPS, user, employmentType]);

  const scheduleClosingDate = useCallback(async () => {
    setPersonaDialogIsOpen(false);
    if (isUnsupportedCountyFips === false) {
      const response = await API.post({
        url: `/schedule-closing-date`,
        data: {
          loanId: loan?.id,
          date: moment(
            loan?.borrowerSteps?.scheduleClosingVerification?.tentativeDate ??
              dateClosing,
          )
            .set("hour", 12)
            .toString(),
        },
      });
      if ("error" in response) {
        console.error(response);
      }
    }

    if (loan?.property?.borrowerFullAddress) {
      setSigningAddress(loan?.property?.borrowerFullAddress);
    }
  }, [
    dateClosing,
    isUnsupportedCountyFips,
    loan?.borrowerSteps?.scheduleClosingVerification.tentativeDate,
    loan?.property?.borrowerFullAddress,
    loan?.id,
  ]);

  useEffect(() => {
    if (loan?.property?.borrowerFullAddress) {
      setSigningAddress(loan?.property?.borrowerFullAddress);
    }
  }, [
    loan?.finalOffer?.amount,
    loan?.borrowerFlags?.reAcceptedFinalOffer,
    loan?.borrowerSteps?.appraisalVerification?.needRecalculate,
    loan?.borrowerSteps?.appraisalVerification?.status,
    loan?.property?.borrowerFullAddress,
    loan?.borrowerSteps?.scheduleClosingVerification?.date,
    loan?.borrowerSteps?.scheduleClosingVerification?.exos,
  ]);

  const handleCloseModal = useCallback(() => {
    setCalendarIsOpen(false);
    setShowChooseAddress(true);
    setShowSigningAddressForm(false);
    setCustomSigningAddress({
      address: "",
      city: "",
      state: "",
      zip: "",
      county: "",
    });
  }, []);

  const tooltipMessage = useMemo(() => {
    if (isBorrower) {
      return "Please confirm if the closing date is convenient for you. You may delay closing for a certain amount of time, however, sometimes delays may cause the loan to require additional underwriting because all of the verifications are time-sensitive.";
    }

    if (!isBorrower) {
      return "You're all set! The Primary Borrower should now have the option to select a closing date.";
    }
  }, [isBorrower]);

  return (
    <CTrackerTimelineItem
      status={status}
      title={isBorrower ? "Select Closing Date" : "Closing Date"}
      tooltip={tooltipMessage}
      {...(prevStep &&
        isBorrower &&
        status === "analyzing" &&
        showBtnClosingDateTexas && {
          action: {
            message: "Pick a closing date",
            onClick: () => {
              if (isUnsupportedCountyFips) {
                setDateClosing(addWorkingDays(moment(), 1));
                setCalendarIsOpen(true);
              } else {
                tentativeDate();
              }
            },
          },
        })}
    >
      <Typography variant="h6" color={[trackerStatusColor[status]]}>
        {status === "analyzing" && message ? message : ""}
        {(status === "failed" &&
          step?.disclosuresVerification?.messageToBorrower) ??
          message}
        {status === "success" && message}
      </Typography>
      <CDialog maxWidth="xs" open={calendarIsOpen} onClose={handleCloseModal}>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Typography
            fontFamily="Pro Display Semibold"
            fontSize={30}
            whiteSpace="nowrap"
            textAlign="left"
          >
            {isUnsupportedCountyFips
              ? "Closing Date"
              : "How Does Closing Work?"}
          </Typography>
          <IconButton onClick={handleCloseModal}>
            <Close fontSize="large" />
          </IconButton>
        </Box>
        {!isUnsupportedCountyFips && (
          <Fragment>
            <Box justifyContent="flex-start" display="flex" width={150} my={3}>
              <img
                alt="Notarize Logo"
                src={NotarizeLogo}
                style={{ width: "100%", transform: "translateX(-5px)" }}
              />
            </Box>
            <Typography textAlign="left" fontFamily="Pro Text Light">
              <strong>NFTYDoor</strong> is partnered with the #1 eClosing
              platform, Notarize.{" "}
              <strong>Once you select a date for closing</strong> Notarize and
              NFTYDoor will send you an email to access the digital closing
              room. If you need to change the date, just let us know.
            </Typography>
          </Fragment>
        )}
        <CCalendar
          date={selectedDate}
          excludeHollidays
          rangeFrom={rangeFrom}
          rangeTo={rangeTo}
          onChange={(newDate) => setSelectedDate(newDate)}
          sx={{ width: 350, mx: "auto", mt: 3 }}
        />

        {isUnsupportedCountyFips && isTexas && (
          <Fragment>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <TimePicker
                defaultValue={dayjs(selectedTime)}
                sx={{ width: "90%", my: 1 }}
                minTime={dayjs()
                  .set("hour", 8)
                  .set("minute", 29)
                  .set("seconds", 59)}
                maxTime={dayjs()
                  .set("hour", 16)
                  .set("minute", 0)
                  .set("seconds", 59)}
                onChange={(newValue) => {
                  setSelectedTime(newValue);
                }}
                onError={(newError) =>
                  !newError
                    ? setTimePickerError(false)
                    : setTimePickerError(true)
                }
                viewRenderers={{
                  hours: renderTimeViewClock,
                  minutes: renderTimeViewClock,
                  seconds: renderTimeViewClock,
                }}
                slotProps={{
                  textField: {
                    readOnly: true,
                  },
                }}
              />
            </LocalizationProvider>

            {timePickerError && (
              <Typography
                color="#ef6161"
                fontSize={15}
                fontFamily="Pro Text Light"
              >
                Please select a time between 8:30 am and 4 pm
              </Typography>
            )}

            {!showSigningAddressForm && (
              <Fragment>
                <Typography
                  mt={2}
                  textAlign="center"
                  fontFamily="Pro Text Light"
                  fontSize={15}
                >
                  Do you want to use this address to complete the signing
                  process?
                </Typography>

                <CTextField
                  sx={{ width: "90%", mb: 1 }}
                  label="Signing address"
                  placeholder="Signing address"
                  value={signingAddress}
                  disabled={true}
                />
              </Fragment>
            )}

            {showChooseAddress && !showSigningAddressForm && (
              <Container
                sx={{ display: "flex", justifyContent: "space-around" }}
              >
                <CButton
                  variant="contained"
                  sx={{ marginTop: 1, width: "40%", height: 50 }}
                  onClick={() => {
                    setShowSigningAddressForm(true);
                    setShowChooseAddress(false);
                  }}
                >
                  No
                </CButton>
                <CButton
                  variant="contained"
                  sx={{ marginTop: 1, width: "40%", height: 50 }}
                  onClick={() => setShowChooseAddress(false)}
                >
                  Yes
                </CButton>
              </Container>
            )}

            {showSigningAddressForm && (
              <Fragment>
                <CTextField
                  sx={{ width: "90%", mb: 1 }}
                  placeholder="Address Line Eg.: 8100 Summer Rest"
                  onChange={(e) =>
                    setCustomSigningAddress((prev) => {
                      return {
                        ...prev,
                        address: e.target.value,
                      };
                    })
                  }
                />
                <CTextField
                  sx={{ width: "90%", mb: 1 }}
                  placeholder="City"
                  onChange={(e) =>
                    setCustomSigningAddress((prev) => {
                      return {
                        ...prev,
                        city: e.target.value,
                      };
                    })
                  }
                />
                <CTextField
                  sx={{ width: "90%", mb: 1 }}
                  placeholder="State abbreviation. Eg.: FL"
                  onChange={(e) =>
                    setCustomSigningAddress((prev) => {
                      return {
                        ...prev,
                        state: e.target.value,
                      };
                    })
                  }
                />
                <CTextField
                  sx={{ width: "90%", mb: 1 }}
                  placeholder="Zipcode"
                  onChange={(e) =>
                    setCustomSigningAddress((prev) => {
                      return {
                        ...prev,
                        zip: e.target.value,
                      };
                    })
                  }
                />
                <CTextField
                  sx={{ width: "90%", mb: 1 }}
                  placeholder="County"
                  onChange={(e) =>
                    setCustomSigningAddress((prev) => {
                      return {
                        ...prev,
                        county: e.target.value,
                      };
                    })
                  }
                />
              </Fragment>
            )}
          </Fragment>
        )}

        <CButton
          fullWidth
          disabled={disableSubmit}
          variant="contained"
          sx={{ marginTop: 3 }}
          onClick={handleSelectConfirm}
        >
          Confirm
        </CButton>
      </CDialog>
      <CDialog
        maxWidth="xs"
        title={`Your closing date is set for ${selectedDate?.toDateString()} ${
          isTexas ? `at ${dayjs(selectedTime)?.format("hh:mm a")}` : ""
        }`}
        description={`${
          isUnsupportedCountyFips
            ? `Your closing documents will be generated with this date in mind. Please sign upon receipt.
            You will recieve instructions about your closing documents by email shortly.`
            : `Your closing documents will be generated with this date in mind. Please sign upon receipt. 
            You will recieve your closing documents by email shortly.On the day of closing - You and other 
            signing parties will be able to login to Notarize.com at any time that day. You will connect 
            with a Notary and sign the documents that require notarization. This will complete your signings for this loan.`
        }`}
        open={confirm}
        onClose={() => {
          setConfirm(false);
          handleCloseModal();
        }}
      >
        <CButton
          fullWidth
          disabled={disableSubmit}
          loading={schedulingDate}
          onClick={scheduleDate}
          variant="contained"
          sx={{ marginBottom: 3, marginTop: 1 }}
        >
          Got it
        </CButton>
      </CDialog>

      <CDialog
        maxWidth="xs"
        open={personaDialogIsOpen}
        onClose={() => setPersonaDialogIsOpen(false)}
      >
        <Box
          mb={3}
          display="flex"
          justifyContent={"space-around"}
          alignItems={"center"}
        >
          <Typography
            sx={{ whiteSpace: "nowrap" }}
            width={280}
            variant="h5"
            fontSize={30}
            textAlign="center"
            fontFamily={"Pro Display Semibold"}
          >
            Confirm Closing Date
          </Typography>
          <Box>
            <IconButton onClick={() => setPersonaDialogIsOpen(false)}>
              <Close
                fontSize="large"
                htmlColor={theme.palette.text.secondary}
              />
            </IconButton>
          </Box>
        </Box>

        <Typography variant="h6" fontFamily="Pro Display Semibold">
          Provided that all your closing conditions are met, your tentative
          closing date is{" "}
          {moment(
            borrowerSteps?.scheduleClosingVerification?.tentativeDate ??
              dateClosing,
          ).format("LL")}
          . Please confirm if this date is acceptable. If you need to
          reschedule, that may cause further delays because the underwriting is
          time-sensitive.
        </Typography>

        <CButton
          fullWidth
          type="submit"
          variant="contained"
          onClick={() => scheduleClosingDate()}
          sx={{ marginTop: 4 }}
        >
          Accept date
        </CButton>

        <CButton
          fullWidth
          variant="outlined"
          type="submit"
          onClick={() => {
            setPersonaDialogIsOpen(false);
            setCalendarIsOpen(true);
          }}
          sx={{ marginTop: 4 }}
        >
          Change the closing date
        </CButton>
      </CDialog>
    </CTrackerTimelineItem>
  );
};

export default ScheduleClosingVerification;
